'use client'

import { useLocale } from 'next-intl'
import { useEffect, useState } from 'react'

type Props = {
	startValue: number
	increment?: number
	period?: number
}

export const CountUp = ({ startValue, increment = 1, period = 1 }: Props) => {
	const locale = useLocale()
	const [count, setCount] = useState(startValue)
	const [minChars] = useState(
		() => new Intl.NumberFormat(locale).format(startValue).length,
	)

	useEffect(() => {
		const interval = setInterval(() => {
			setCount((prev) => prev + increment)
		}, period * 1000)
		return () => clearInterval(interval)
	}, [increment, period])

	return (
		<span
			className="inline-block text-center tabular-nums -mx-1"
			style={{ minWidth: `${minChars}ch` }}
		>
			{new Intl.NumberFormat(locale).format(count)}
		</span>
	)
}
